import { DebugView } from '@/ui';

export type VideoStatsLinkProps = {
  videoId: string;
  videoServerUrl: string | null | undefined;
  className?: string;
};

export function VideoStatsLink({ videoId, videoServerUrl, className }: VideoStatsLinkProps) {
  if (videoServerUrl == null || videoServerUrl.trim() === '') {
    return null;
  }

  const statsUrl = `${videoServerUrl.replace(/\/+$/, '')}/stats/${encodeURIComponent(videoId)}`;

  return (
    <DebugView>
      <a
        className={className}
        href={statsUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(event) => event.stopPropagation()}
      >
        Video stats
      </a>
    </DebugView>
  );
}
